(function(window, $){
    if(!window.SwymCallbacks){window.SwymCallbacks = [];}

    window.SwymCallbacks.push(function(){
        _swat.fetchWrtEventTypeET(function(products){
            wishlistRender(products);
        }, _swat.EventTypes.addToWishlist);
    });

  wishlistRender = function(products) {
  $(document).ready(function() {
    var template = $('[data-wishlist-template]');
    var empty_template = $('[data-wishlist-empty]');
    var $wishlistContainer = $('#wishlist-content');

    var startLoading = function($context) {
        if($context) {
            $context.addClass('loading');
        } else {
            $wishlistContainer.addClass('loading');
        }
    }

    var stopLoading = function($context) {
        if($context) {
            $context.removeClass('loading');
        } else {
            $wishlistContainer.removeClass('loading');
        }
    }

    if (!products || products.length < 1) {
      empty_template.show();
      return;
    }

    products.forEach(function(p) {
      var row = template.clone();

      row.removeClass('hidden');
      row.find('[data-name]').html(p.dt);
      row.find('[data-url]').attr('href', p.du);
      row.find('[data-image]').attr('src', p.iu);
      row.find('[data-variant]').html(p.vi);
      row.find('[data-price]').html(p.pr + _swat.currency);

     /*  if(!p.stk) {
        row.find('[data-add]').addClass('disabled');
      } */


      row.find('[data-remove]').on('click', function(e) {
        e.preventDefault();
        console.log(p._id);
        startLoading(row);

        _swat.removeFromWishList(p, function callback() {
          row.remove();
          window.loadWishlistBubble();
          stopLoading(row);
        });
      });

      row.find('[data-add]').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;

        startLoading(row);

        $.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {
                items: [
                    {
                        id: parseInt(p.epi),
                        quantity: 1
                    }
                ]
            },
            success: function() { // Done
                window.loadWishlistBubble();

                if(ajaxCart && timber && timber.RightDrawer) {
                    ajaxCart.load();
                    timber.RightDrawer.open();
                }
            },
            error: function(resp){
                var error = JSON.parse(resp.responseText);
                row.find('[data-errors]').html('<span class="snackbar snackbar--error">'+ error.description +'</span>')
            },
            dataType: 'json'
          }
        )
        .always(function(){
            stopLoading(row);
        });
      });

      $wishlistContainer.append(row);
    });
  });
 }
})(window, jQuery);
